import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
import ProfileService from '@/core/services/profile.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateProfileComponent extends Vue {

  profileService: any = new ProfileService();
  sidebarService: any = new SidebarService();
  showModalProfile: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  showButtonCreate: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  messageContinue: boolean = false;
  button: boolean = false;
  nextOne: boolean = true;
  nextTwo: boolean = false;
  nextThree: boolean = false;
  nextFour: boolean = false;
  nextFive: boolean = false;
  nextSix: boolean = false;
  nextSeven: boolean = false;
  nextEight: boolean = false;
  nextNine: boolean = false;
  nextTen: boolean = false;
  nextEleven: boolean = false;
  nextTwelve: boolean = false;
  profileHierarchyOne: string = "";
  profileHierarchyTwo: string = "";
  profileHierarchyThree: string = "";
  profileHierarchyFour: string = "";
  profileHierarchyFive: string = "";
  profileHierarchySix: string = "";
  profileHierarchySeven: string = "";
  profileHierarchyEight: string = "";
  profileHierarchyNine: string = "";
  profileHierarchyTen: string = "";
  profileHierarchyEleven: string = "";
  profileHierarchyTwelve: string = "";
  averageEffectiveness: string = "";
  genericErr: any = [];
  businessList: any = [];
  companyList: any = [];
  skills: any = [];
  sumaProfile: any = [];
  name: string = "";
  companies: string = "defaultCompany";
  hierarchies = 0;
  pastHierarchies = [];
  manualMode: boolean = false;
  business: string = "";
  hierarchiesList = [
    {
      domain_1: 43,
      domain_2: 57,
      domain_3: 70,
      domain_4: 82,
      domain_5: 93,
    },
    {
      domain_1: 40,
      domain_2: 54,
      domain_3: 67,
      domain_4: 79,
      domain_5: 90,
    },
    {
      domain_1: 38,
      domain_2: 52,
      domain_3: 65,
      domain_4: 77,
      domain_5: 88,
    },
    {
      domain_1: 35,
      domain_2: 49,
      domain_3: 62,
      domain_4: 74,
      domain_5: 85,
    },
    {
      domain_1: 33,
      domain_2: 47,
      domain_3: 60,
      domain_4: 72,
      domain_5: 83,
    },
    {
      domain_1: 30,
      domain_2: 44,
      domain_3: 57,
      domain_4: 69,
      domain_5: 80,
    },
    {
      domain_1: 28,
      domain_2: 42,
      domain_3: 55,
      domain_4: 67,
      domain_5: 78,
    },
    {
      domain_1: 25,
      domain_2: 39,
      domain_3: 52,
      domain_4: 64,
      domain_5: 75,
    },
    {
      domain_1: 23,
      domain_2: 37,
      domain_3: 50,
      domain_4: 62,
      domain_5: 73,
    },
    {
      domain_1: 20,
      domain_2: 34,
      domain_3: 47,
      domain_4: 59,
      domain_5: 70,
    },
    {
      domain_1: 18,
      domain_2: 32,
      domain_3: 45,
      domain_4: 57,
      domain_5: 68,
    },
    {
      domain_1: 15,
      domain_2: 29,
      domain_3: 42,
      domain_4: 54,
      domain_5: 65,
    }
  ]

  hierarchiesName = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  mounted() {
    const _ = this;
    _.getCompanies();
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  openModal() {
    const _ = this;
    _.showModalProfile = true;
  }

  closeModal() {
    const _ = this;
    _.showModalProfile = false;
  }

  openModalButton() {
    const _ = this;
    _.showModalProfile = true;
    _.showButtonCreate = true;
  }

  public handleHierarchies(next?: boolean) {
    const _ = this;
    if(next){
      _.pastHierarchies.push(_.hierarchiesName[_.hierarchies])
      _.hierarchiesName.splice(_.hierarchies, 1)
      return;
    }
    
    _.hierarchiesName.push(_.pastHierarchies.at(-1))
    _.pastHierarchies.pop()
    console.log(_.pastHierarchies, " again past")
    _.hierarchiesName.sort((a, b) => (a - b));

  }

  clickBackOne() {
    const _ = this;
    _.nextOne = true;
    _.nextTwo = false;
    _.handleHierarchies(false)
  }

  clickNextTwo(next: boolean) {
    const _ = this;
    if (_.profileHierarchyOne == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
      console.log(' On back is 1?');
    } else {
        console.log(' On back is 2?');
      _.nextOne = false;
      _.nextTwo = true;
      _.nextThree = false;
      _.handleHierarchies(next)
    }
  }

  clickNextThree(next: boolean) {
    const _ = this;
    if (_.profileHierarchyTwo == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextTwo = false;
      _.nextThree = true;
      _.nextFour = false;
      _.handleHierarchies(next)
    }
  }

  clickNextFour(next: boolean) {
    const _ = this;
    if (_.profileHierarchyThree == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextThree = false;
      _.nextFour = true;
      _.nextFive = false;
      _.handleHierarchies(next)
    }
  }

  clickNextFive(next: boolean) {
    const _ = this;
    if (_.profileHierarchyFour == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextFour = false;
      _.nextFive = true;
      _.nextSix = false;
      _.handleHierarchies(next)
    }
  }

  clickNextSix(next: boolean) {
    const _ = this;
    if (_.profileHierarchyFive == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextFive = false;
      _.nextSix = true;
      _.nextSeven = false;
      _.handleHierarchies(next)
    }
  }

  clickNextSeven(next: boolean) {
    const _ = this;
    if (_.profileHierarchySix == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextSix = false;
      _.nextSeven = true;
      _.nextEight = false;
      _.handleHierarchies(next)
    }
  }

  clickNextEight(next: boolean) {
    const _ = this;
    if (_.profileHierarchySeven == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextSeven = false;
      _.nextEight = true;
      _.nextNine = false;
      _.handleHierarchies(next)
    }
  }

  clickNextNine(next: boolean) {
    const _ = this;
    if (_.profileHierarchyEight == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextEight = false;
      _.nextNine = true;
      _.nextTen = false;
      _.handleHierarchies(next)
    }
  }

  clickNextTen(next: boolean) {
    const _ = this;
    if (_.profileHierarchyNine == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextNine = false;
      _.nextTen = true;
      _.nextEleven = false;
      _.handleHierarchies(next)
    }
  }

  clickNextEleven(next: boolean) {
    const _ = this;
    if (_.profileHierarchyTen == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextTen = false;
      _.nextEleven = true;
      _.nextTwelve = false;
      _.handleHierarchies(next)
    }
  }

  clickNextTwelve(next: boolean) {
    const _ = this;
    if (_.profileHierarchyEleven == '') {
      _.messageContinue = true;
      _.modal = true;
      _.error = true;
    } else {
      _.nextEleven = false;
      _.nextTwelve = true;
      _.handleHierarchies(next)
    }
  }

  effectivenessProfile() {
    const _ = this;
    _.sumaProfile = (
      +_.profileHierarchyOne + +_.profileHierarchyTwo +
      +_.profileHierarchyThree + +_.profileHierarchyFour +
      +_.profileHierarchyFive + +_.profileHierarchySix +
      +_.profileHierarchySeven + +_.profileHierarchyEight +
      +_.profileHierarchyNine + +_.profileHierarchyTen +
      +_.profileHierarchyEleven + +_.profileHierarchyTwelve
    )
    _.averageEffectiveness = (_.sumaProfile / 12).toFixed(0);
  }

  getCompanies() {
    const _ = this;
    _.isLoading = true;
    _.profileService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      _.companyList.sort(function(a, b) {
        var textA = a.name.toLowerCase();
        var textB = b.name.toLowerCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
      .catch((err: any) => {
        if (err.response.data.message.includes('Invalid or inexistent user')) {
          localStorage.removeItem('tk_auth');
          _.logInModal = true;
        }
        _.isLoading = false;
      })
  }

  test() {
    const _ = this;
    console.log(_.companies);
  }

  create() {
    const _ = this;
    let profile = {
      name: _.name,
      companyId: _.companies,
      skills: [
        {
          skillId: 9,
          expectedPercentage: _.profileHierarchyOne
        },
        {
          skillId: 10,
          expectedPercentage: _.profileHierarchyTwo
        },
        {
          skillId: 11,
          expectedPercentage: _.profileHierarchyThree
        },
        {
          skillId: 12,
          expectedPercentage: _.profileHierarchyFour
        },
        {
          skillId: 13,
          expectedPercentage: _.profileHierarchyFive
        },
        {
          skillId: 14,
          expectedPercentage: _.profileHierarchySix
        },
        {
          skillId: 15,
          expectedPercentage: _.profileHierarchySeven
        },
        {
          skillId: 16,
          expectedPercentage: _.profileHierarchyEight
        },
        {
          skillId: 17,
          expectedPercentage: _.profileHierarchyNine
        },
        {
          skillId: 18,
          expectedPercentage: _.profileHierarchyTen
        },
        {
          skillId: 19,
          expectedPercentage: _.profileHierarchyEleven
        },
        {
          skillId: 20,
          expectedPercentage: _.profileHierarchyTwelve
        },
      ]
    };
    console.log(profile);
    _.isLoading = true;
    _.profileService.create(profile).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/profile');
      }, 2000)
    })
      .catch((err: any) => {
        _.modal = true;
        _.error = true;
        _.isErrorServer = true;
        setTimeout(() => {
          _.isLoading = false;
        }, 2000)
      })
  }

  validations(name = '', companies = '') {
    const _ = this;
    _.genericErr = [];
    if (name == '') {
      _.genericErr.push("Por favor escribe el nombre del perfil");
    }
    if (companies == '') {
      _.genericErr.push("Por favor selecciona una compañía");
    }
    if (_.genericErr.length > 0) {
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
